import { Form, useForm } from '@/components/forms';
import Input from '@/components/forms/Input';
import Textarea from '@/components/forms/Textarea';
import { useDynamicLocale } from '@/hoslog-intl';
import { ChargeSubcategoryDetail } from '@/services/charges/charges.types';
import { z } from 'zod';
import { useAddSubcategory, useUpdateSubcategory } from './hooks/useManageSubcategory';

const manageChargeSubCategorySchema = z.object({
  chargeCategoryId: z.string().min(1, { message: 'common.form.validation.required' }),
  agentType: z.string().min(1, { message: 'common.form.validation.required' }),
  categoryType: z.string().trim().min(1, { message: 'common.form.validation.required' }),
  description: z.string().trim().optional(),
});

export const ManageChargeSubCategoryForm = ({
  categoryId,
  agentType,
  chargeSubCategoryId,
  data,
}: {
  categoryId?: string;
  agentType?: string;
  chargeSubCategoryId?: string;
  data?: ChargeSubcategoryDetail;
}) => {
  const { t } = useDynamicLocale();
  const form = useForm({
    schema: manageChargeSubCategorySchema,
    mode: 'onBlur',
    defaultValues: {
      chargeCategoryId: categoryId || '',
      agentType: agentType || '',
      categoryType: data?.categoryType || '',
      description: data?.description || '',
    },
  });
  const { mutateAsync } = useUpdateSubcategory();
  const { mutateAsync: addSubcategory } = useAddSubcategory();
  return (
    <Form
      form={form}
      onSubmit={async (data) => {
        if (chargeSubCategoryId) {
          await mutateAsync({
            chargeSubCategoryId,
            chargeCategoryId: categoryId || '',
            agentType: agentType || '',
            categoryType: data.categoryType,
            description: data.description || '',
          });
        } else {
          await addSubcategory({
            chargeCategoryId: categoryId || '',
            agentType: agentType || '',
            categoryType: data.categoryType,
            description: data.description || '',
          });
        }
      }}
    >
      <div className="w-full flex flex-col gap-[18px]">
        <Input
          {...form.register('categoryType')}
          label="configurationManagement.charges.chargeSubCategory.table.categoryType"
          placeholder={t('configurationManagement.charges.chargeSubCategory.table.categoryType')}
          maxLength={50}
          forceRequired
        />
        <Textarea
          label="configurationManagement.charges.manageChargeSlabModal.description"
          {...form.register('description')}
          placeholder={t('configurationManagement.charges.manageChargeSlabModal.placeholder.writeSomething')}
          className="resize-none"
          maxLength={200}
        />
      </div>
    </Form>
  );
};
